import { CountryEnv } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_HK_UQ || "uqhk-sth-sb-proxy",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_HK_UQ || 27205,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_HK_UQ || 29354,
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY_HK_UQ || "",
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_HK_UQ || "",
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID_HK_UQ || "",
  firebaseMeasurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_HK_UQ || "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  faqUrl: "https://faq-hk.uniqlo.com/",
  faqUrlForEn: "https://faq-hk.uniqlo.com/pkb_Home_UQ_HK?l=en_US",
  showAboutApp: true
};

export default _countryEnv;
